import axios from "axios";
import {
  SetLocalStorage,
  RecordingDataDecode,
} from "../../../general/functions/base64Function";
import {
  AUTH_RECORDING_DATA_FAIL,
  AUTH_RECORDING_DATA_REQUEST,
  AUTH_RECORDING_DATA_SUCCESS,
} from "../constants/recordingAuthConstants";
import { API_RECORDING_LIST, API_SESSION_INFO } from "../init/urlApi";
import {
  record_interview_info_dummy,
  record_interview_users_dummy,
} from "../dummy/record_interview_dummy";

export const AuthRecordingDataAction = (base64Data) => async (dispatch) => {
  try {
    dispatch({
      type: AUTH_RECORDING_DATA_REQUEST,
    });

    let objTmp = {};
    let authFrom = RecordingDataDecode(base64Data);
    console.log("decode", authFrom);
    objTmp.token = authFrom.token;
    objTmp.session = authFrom.session;
    objTmp.uId = authFrom.uId;
    objTmp.agoraToken = authFrom.agoraToken;

    const config = {
      headers: {
        Authorization: `Bearer ${objTmp.token}`,
        "Content-Type": "application/json",
      },
    };
    const { data: user } = await axios.get(
      API_RECORDING_LIST(objTmp.session),
      config
    );
    console.log("Get user List", user.data);
    let userTmp = user.data?.find((x) => x.uid == objTmp.uId);
    let recordTmp = user.data?.filter((x) => x.type == "RECORDING");
    let screenShareTmp = user.data?.filter((x) => x.type == "SHARE_SCREEN");

    objTmp.user = {
      uId: userTmp?.uid,
      name: userTmp?.name,
      email: userTmp?.email,
      type: userTmp?.type,
    };
    objTmp.feature = { recordUid: recordTmp, shareScreenUid: screenShareTmp };

    objTmp.listUser = user.data?.map((x) => {
      return {
        uId: x.uid,
        name: x.name,
        email: x.email,
        type: x.type,
      };
    });

    const { data: sessionInfo } = await axios.get(
      API_SESSION_INFO(objTmp.session),
      config
    );

    objTmp.sessionInfo = {
      projectId: sessionInfo.data.projectCode,
      mehodId: sessionInfo.data.methodId,
      methodName: sessionInfo.data.methodName,
      uiMode: sessionInfo.data.uiMode,
      startTime: sessionInfo.data.startTime,
      sessionTitle: sessionInfo.data.sessionTitle,
    };
    SetLocalStorage("bkdp_id_rec", base64Data);
    dispatch({
      type: AUTH_RECORDING_DATA_SUCCESS,
      payload: objTmp,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({
      type: AUTH_RECORDING_DATA_FAIL,
      payload: message,
    });
  }
};

export const AuthRecordingDataActionDUMMY =
  (base64Data) => async (dispatch) => {
    try {
      dispatch({
        type: AUTH_RECORDING_DATA_REQUEST,
      });

      let objTmp = {};
      let authFrom = RecordingDataDecode(base64Data);
      console.log("decode", authFrom);
      objTmp.token = authFrom.token;
      objTmp.session = authFrom.session;
      objTmp.uId = authFrom.uId;
      objTmp.agoraToken = authFrom.agoraToken;
      console.log("Recoding Action 105", objTmp);

      // const config = {
      //   headers: {
      //     Authorization: `Bearer ${objTmp.token}`,
      //     "Content-Type": "application/json",
      //   },
      // };
      const user = record_interview_users_dummy;
      console.log("Get user List", user.data);
      let userTmp = user.data?.find((x) => x.uid == objTmp.uId);
      let recordTmp = user.data?.filter((x) => x.type == "RECORDING");
      let screenShareTmp = user.data?.filter((x) => x.type == "SHARE_SCREEN");

      objTmp.user = {
        uId: userTmp?.uid,
        name: userTmp?.name,
        email: userTmp?.email,
      };
      objTmp.feature = { recordUid: recordTmp, shareScreenUid: screenShareTmp };

      objTmp.listUser = user.data?.map((x) => {
        return {
          uId: x.uid,
          name: x.name,
          email: x.email,
          type: x.type,
        };
      });
      console.log("Recoding Action 133", objTmp);

      const sessionInfo = record_interview_info_dummy;

      objTmp.sessionInfo = {
        projectId: sessionInfo.data.projectCode,
        mehodId: sessionInfo.data.methodId,
        methodName: sessionInfo.data.methodName,
        uiMode: sessionInfo.data.uiMode,
        startTime: sessionInfo.data.startTime,
        sessionTitle: sessionInfo.data.sessionTitle,
      };
      console.log("Recoding Action 145", objTmp);

      SetLocalStorage("bkdp_id_rec", base64Data);
      dispatch({
        type: AUTH_RECORDING_DATA_SUCCESS,
        payload: objTmp,
      });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({
        type: AUTH_RECORDING_DATA_FAIL,
        payload: message,
      });
    }
  };

export const AuthRecordingDataActionOld = (base64Data) => async (dispatch) => {
  try {
    dispatch({
      type: AUTH_RECORDING_DATA_REQUEST,
    });

    let objTmp = {};
    let authFrom = RecordingDataDecode(base64Data);
    console.log(authFrom);
    objTmp.token = authFrom.token;
    objTmp.session = authFrom.session;
    objTmp.uId = authFrom.uId;
    objTmp.agoraToken = authFrom.agoraToken;

    objTmp.user = {
      uId: authFrom.uId,
      name: "Testing",
      email: "Testing@test.com",
    };
    objTmp.feature = {
      recordUid: [{ uid: 999 }],
      shareScreenUid: [{ uid: 998 }],
    };

    objTmp.sessionInfo = {
      projectId: "PR-TEST",
      mehodId: "2",
      methodName: "INTERVIEW TEST",
      uiMode: "INTERVIEW_ASSESSOR",
      startTime: 1696919685,
    };

    SetLocalStorage("bkdp_id_rec", base64Data);

    dispatch({
      type: AUTH_RECORDING_DATA_SUCCESS,
      payload: objTmp,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({
      type: AUTH_RECORDING_DATA_FAIL,
      payload: message,
    });
  }
};
